/* Example dashboard (sections/st-app.liquid; v5 app section). Example data only.
   The daily series is built from the section's totals: a weekly rhythm with a gentle rise, scaled so
   the days before today add up to the month total minus today, and today is its own figure. Dates
   and numbers are formatted in the page's language. */
(() => {
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const NS = 'http://www.w3.org/2000/svg';

  const init = (dash) => {
    if (dash.dataset.stReady) return;
    dash.dataset.stReady = '1';
    const lang = document.documentElement.lang || 'en';
    const fmtN = new Intl.NumberFormat(lang);
    const fmtDay = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtAxis = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
    const total = Number(dash.dataset.month) || 0;
    const today = Number(dash.dataset.today) || 0;
    const days = Math.max(2, Number(dash.dataset.days) || 25);
    const year = Number(dash.dataset.year) || 2026;
    const mi = Math.min(12, Math.max(1, Number(dash.dataset.monthIndex) || 9)) - 1;
    const dateOf = (i) => new Date(year, mi, i + 1);

    // Series: weekday weights (Sun to Sat), a slow rise and a little wobble.
    const W = [1.3, 0.8, 0.85, 0.9, 1, 1.25, 1.5];
    const raw = [];
    for (let i = 0; i < days - 1; i++) raw.push(W[dateOf(i).getDay()] * (1 + i * 0.013) * (1 + 0.12 * Math.sin((i + 1) * 2.1)));
    const sum = raw.reduce((a, b) => a + b, 0) || 1;
    const rest = Math.max(0, total - today);
    const data = raw.map((v) => Math.round((v * rest) / sum));
    data[0] += rest - data.reduce((a, b) => a + b, 0);
    data.push(today);

    const tbody = dash.querySelector('[data-st-dash-table] tbody');
    data.forEach((v, i) => {
      const tr = document.createElement('tr');
      const th = document.createElement('th');
      th.scope = 'row';
      th.textContent = fmtDay.format(dateOf(i));
      const td = document.createElement('td');
      td.textContent = fmtN.format(v);
      tr.append(th, td);
      tbody.appendChild(tr);
    });

    const svg = dash.querySelector('[data-st-dash-svg]');
    const plot = dash.querySelector('[data-st-dash-plot]');
    const tip = dash.querySelector('[data-st-dash-tip]');
    const top = Math.max(25, Math.ceil(Math.max(...data) / 25) * 25);
    const step = top <= 100 ? 25 : Math.ceil(top / 4 / 25) * 25;
    let geo = null;
    const el = (name, attrs, parent) => {
      const e = document.createElementNS(NS, name);
      Object.entries(attrs).forEach(([k, v]) => e.setAttribute(k, v));
      (parent || svg).appendChild(e);
      return e;
    };
    const draw = (animate) => {
      const w = plot.clientWidth;
      const h = plot.clientHeight;
      const m = { l: 28, r: 64, t: 10, b: 22 };
      const iw = Math.max(10, w - m.l - m.r);
      const ih = Math.max(10, h - m.t - m.b);
      svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
      svg.replaceChildren();
      const X = (i) => m.l + (i / (data.length - 1)) * iw;
      const Y = (v) => m.t + ih - (v / top) * ih;
      const g = el('g', { class: 'st-dash__grid' });
      for (let t = 0; t <= top; t += step) {
        el('line', { x1: m.l, x2: m.l + iw, y1: Y(t), y2: Y(t) }, g);
        el('text', { x: m.l - 6, y: Y(t) + 4, 'text-anchor': 'end' }, g).textContent = fmtN.format(t);
      }
      [0, 7, 14, 21].filter((i) => i < data.length - 1).forEach((i) => {
        el('text', { x: X(i), y: h - 4, 'text-anchor': i ? 'middle' : 'start', class: 'st-dash__axis' }).textContent = fmtAxis.format(dateOf(i));
      });
      const pts = data.map((v, i) => [X(i), Y(v)]);
      const d = 'M' + pts.map((p) => `${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' L');
      el('path', { class: 'st-dash__area', d: `${d} L${X(data.length - 1)} ${Y(0)} L${X(0)} ${Y(0)} Z` });
      const line = el('path', { class: 'st-dash__line', d });
      if (animate) {
        const len = line.getTotalLength();
        line.style.strokeDasharray = len;
        line.style.strokeDashoffset = len;
        line.getBoundingClientRect();
        line.classList.add('is-drawing');
        line.style.strokeDashoffset = 0;
      }
      const e = pts[pts.length - 1];
      const end = el('g', { class: 'st-dash__end' });
      el('circle', { cx: e[0], cy: e[1], r: 6, class: 'st-dash__halo' }, end);
      el('circle', { cx: e[0], cy: e[1], r: 4, class: 'st-dash__pt' }, end);
      el('text', { x: e[0] + 10, y: e[1] + 4 }, end).textContent = (dash.dataset.todayLabel || '[n]').replace('[n]', fmtN.format(today));
      const xh = el('line', { class: 'st-dash__xh', y1: m.t, y2: m.t + ih, x1: 0, x2: 0, visibility: 'hidden' });
      const hd = el('circle', { class: 'st-dash__pt st-dash__pt--hover', r: 4, cx: 0, cy: 0, visibility: 'hidden' });
      geo = { X, Y, m, iw, xh, hd };
    };
    const hover = (ev) => {
      if (!geo) return;
      const r = plot.getBoundingClientRect();
      const i = Math.round(((ev.clientX - r.left - geo.m.l) / geo.iw) * (data.length - 1));
      if (i < 0 || i >= data.length) return leave();
      const cx = geo.X(i);
      const cy = geo.Y(data[i]);
      geo.xh.setAttribute('visibility', 'visible');
      geo.hd.setAttribute('visibility', 'visible');
      geo.xh.setAttribute('x1', cx);
      geo.xh.setAttribute('x2', cx);
      geo.hd.setAttribute('cx', cx);
      geo.hd.setAttribute('cy', cy);
      tip.hidden = false;
      const b = document.createElement('b');
      b.textContent = fmtDay.format(dateOf(i));
      const last = i === data.length - 1 ? ` ${dash.dataset.soFar || ''}` : '';
      tip.replaceChildren(b, document.createTextNode(`${fmtN.format(data[i])} ${dash.dataset.scans || ''}${last}`));
      tip.style.left = `${Math.max(56, Math.min(r.width - 56, cx))}px`;
      tip.style.top = `${Math.max(-44, cy - 56)}px`;
    };
    const leave = () => {
      tip.hidden = true;
      if (geo) {
        geo.xh.setAttribute('visibility', 'hidden');
        geo.hd.setAttribute('visibility', 'hidden');
      }
    };
    plot.addEventListener('pointermove', hover);
    plot.addEventListener('pointerdown', hover);
    plot.addEventListener('pointerleave', leave);
    if (!FINE && dash.dataset.touchHint) dash.querySelector('[data-st-dash-hint]').textContent = dash.dataset.touchHint;

    // The link chip: each press moves to the next platform and announces it.
    const P = (dash.dataset.platforms || '').split(',').map((s) => s.trim()).filter(Boolean);
    let pi = 0;
    const chip = dash.querySelector('.st-dash__chip');
    const name = dash.querySelector('[data-st-dash-platform]');
    const note = dash.querySelector('[data-st-dash-note]');
    const setLink = (i) => {
      if (!P.length) return;
      pi = i % P.length;
      name.textContent = P[pi];
      chip.classList.remove('is-flip');
      void chip.offsetWidth;
      chip.classList.add('is-flip');
      const short = P[pi].replace(/\s+\S+$/, '') || P[pi];
      note.textContent = (dash.dataset.note || '').replace('[platform]', short);
    };
    chip.addEventListener('click', () => setLink(pi + 1));

    const count = (node, to, dur) => {
      let t0 = null;
      const f = (t) => {
        if (t0 === null) t0 = t;
        const q = Math.min(1, (t - t0) / dur);
        node.textContent = fmtN.format(Math.round(to * (1 - Math.pow(1 - q, 4))));
        if (q < 1) requestAnimationFrame(f);
      };
      requestAnimationFrame(f);
    };
    dash.querySelectorAll('[data-st-dash-count]').forEach((n) => (n.textContent = fmtN.format(Number(n.dataset.stDashCount) || 0)));

    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      dash.classList.add('is-in');
      draw(true);
      dash.querySelectorAll('[data-st-dash-count]').forEach((n) => {
        const to = Number(n.dataset.stDashCount) || 0;
        count(n, to, to > 100 ? 1800 : 1400);
      });
      setTimeout(() => {
        if (pi === 0) setLink(1);
      }, 2800);
    };
    if (RM || !('IntersectionObserver' in window)) {
      dash.classList.add('is-drawn');
      draw(false);
    } else {
      dash.classList.add('is-armed');
      draw(false);
      const io = new IntersectionObserver(
        (en) => {
          if (en[0].isIntersecting) {
            io.disconnect();
            start();
          }
        },
        { threshold: 0.35 }
      );
      io.observe(dash);
    }
    let rw = plot.clientWidth;
    window.addEventListener('resize', () => {
      if (plot.clientWidth !== rw) {
        rw = plot.clientWidth;
        draw(false);
      }
    });
  };
  const run = () => document.querySelectorAll('[data-st-dash]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
